import { TimeEnum } from "../../../../../lib/enums";

export const INITIAL_NETWORK_FORM_VALUES = {
  urlDomainIP: "",
  classification: {
    label: "",
    value: ""
  },
  resourceType: {
    label: "",
    value: ""
  },
  firstSeen: {
    label: TimeEnum.ALL,
    value: TimeEnum.ALL
  }
};
